import React, { ComponentProps, FC } from 'react'

import { Tag as BaseTag } from '@style-port/roov-ui-components-react'

type Props = ComponentProps<typeof BaseTag>

export const Tag: FC<Props> = props => {
  return <BaseTag {...props} />
}
